"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minimalActivePeriodUtcUnixMillis = exports.pseudoRandom = exports.isLocalhostCheck = exports.isLocalhostEmulator = exports.pathToHttpLocalEmulatedFunction = exports.pathToHttpCloudFunction = exports.pathToHttpLocalExpress = exports.httpsCfUrl = exports.LOCALHOST_URL = exports.LOCALHOST = exports.CLOUDFUNCTIONS_URL = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("../../core/infra/constants");
exports.CLOUDFUNCTIONS_URL = "cloudfunctions.net";
exports.LOCALHOST = "localhost";
exports.LOCALHOST_URL = "http://localhost";
// eslint-disable-next-line node/no-unpublished-import
const config_js_1 = require("../../config.js");
const moment_1 = tslib_1.__importDefault(require("moment"));
function httpsCfUrl(name) {
    var _a;
    // console.log("httpsCfUrl process?.env?.REACT_APP_CF_EXEC_MODE", process?.env?.REACT_APP_CF_EXEC_MODE);
    if (((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_CF_EXEC_MODE) === "LOCAL_EXPRESS")
        return pathToHttpLocalExpress(name);
    if (isLocalhostEmulator())
        return pathToHttpLocalEmulatedFunction(name);
    return pathToHttpCloudFunction(name);
}
exports.httpsCfUrl = httpsCfUrl;
function pathToHttpLocalExpress(name) {
    return `http://localhost:${constants_1.EXPRESS_LOCAL_TESTING_PORT}/${name}`;
}
exports.pathToHttpLocalExpress = pathToHttpLocalExpress;
function pathToHttpCloudFunction(name) {
    return `https://${config_js_1.functionsRegion}-${config_js_1.projectId}.${exports.CLOUDFUNCTIONS_URL}/${name}`;
}
exports.pathToHttpCloudFunction = pathToHttpCloudFunction;
function pathToHttpLocalEmulatedFunction(name) {
    return `http://localhost:${config_js_1.emulators.functions}/${config_js_1.projectId}/${config_js_1.functionsRegion}/${name}`;
}
exports.pathToHttpLocalEmulatedFunction = pathToHttpLocalEmulatedFunction;
function isLocalhostEmulator() {
    var _a, _b, _c;
    return (((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.CF_EXEC_MODE) === "EMULATED" ||
        (((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.hostname) === exports.LOCALHOST && ((_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.port) === (config_js_1.emulators === null || config_js_1.emulators === void 0 ? void 0 : config_js_1.emulators.hosting)));
}
exports.isLocalhostEmulator = isLocalhostEmulator;
function isLocalhostCheck() {
    return window && window.location && window.location.hostname === exports.LOCALHOST;
}
exports.isLocalhostCheck = isLocalhostCheck;
function pseudoRandom(pow) {
    return Math.round(Math.random() * Math.pow(10, pow)).toString(36);
}
exports.pseudoRandom = pseudoRandom;
exports.minimalActivePeriodUtcUnixMillis = () => moment_1.default().utc().subtract(15, "minutes").valueOf();
//# sourceMappingURL=utils.js.map